import { applyMiddleware, createStore, compose, combineReducers } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { authorizations } from '@finect/front-core/Authorizations';
import { user } from '@finect/front-core/User';
import { questions } from './questions/reducers';
// import { user } from './user/reducers';
import { tags } from './tags/reducers';
import { error } from './error/reducers';
import { overlay } from './overlay/reducers';
import { liveEvents } from './liveEvents/reducers';

const reducer = combineReducers({
  user,
  overlay,
  questions,
  tags,
  error,
  authorizations,
  liveEvents
});

/* eslint-disable */
export function configureStore(initialState = {}) {
  return createStore(
    reducer,
    initialState,
    compose(
      applyMiddleware(thunkMiddleware),
      typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__
        ? window.__REDUX_DEVTOOLS_EXTENSION__()
        : f => f
    )
  );
}
/* eslint-enable */

export const mapStateToProps = state => state;
